/**
 * Not used atm when starting to use make sure to add the proper typing to window.d.ts for the window variable
 * import "./site/google";
 */

import.meta.glob([
    '../images/**',
]);

import {createPinia} from "pinia";
import {useLabelStore} from "./site/stores/label";
import {createApp} from 'vue/dist/vue.esm-bundler.js';
import CartOverview from "./site/Components/Cart/CartOverview.vue";
import CartHeader from "./site/Components/Cart/CartHeader.vue";
import AccountHeader from "./site/Components/AccountHeader.vue";
import OfferHeader from "./site/Components/Offer/OfferHeader.vue";
import AddToCart from "./site/Components/Cart/AddToCart.vue";
import AddToCartProject from "./site/Components/AddToCartProject.vue";
import AddToCartDetail from "./site/Components/Product/AddToCartDetail.vue";
import Messages from "./site/Components/Messages.vue";
import Modal from "./site/Components/Modal.vue";
import SearchBar from "./site/Components/Search/SearchBar.vue";
import Skeleton from "./site/Components/Skeleton.vue";
import Images from "./site/Components/Product/Images.vue";
import ProductTabs from "./site/Components/Product/ProductTabs.vue";
import RelatedProducts from "./site/Components/Product/RelatedProducts.vue";
import MainMenu from "./site/Components/MainMenu.vue";
import CategoryMenu from "./site/Components/CategoryMenu.vue";
import LanguageMenu from "./site/Components/LanguageMenu.vue";
import MobileMenu from "./site/Components/MobileMenu.vue";
import {defineAsyncComponent} from "vue";
import PreventInteraction from "./site/Components/PreventInteraction.vue";
import AfterAdding from "./site/Components/Product/AfterAdding.vue";
import AfterAddingOffer from "./site/Components/Offer/AfterAddingOffer.vue";
import StarRating from 'vue-star-rating';
import StockDetail from "./site/Components/Product/StockDetail.vue";

const pinia = createPinia();


const app = createApp({
    mounted() {
        // flash_session();
    },
    created() {
        const labelStore = useLabelStore();
        labelStore.setFromJsonString(window.labels);
    }
});

app.use(pinia);

app.component('CartOverview', CartOverview)
    .component('CartHeader', CartHeader)
    .component('AddToCart', AddToCart)
    .component('AddToCartProject', AddToCartProject)
    .component('AddressInput', defineAsyncComponent(() => import('./site/Components/Address/AddressEntityInput.vue')))
    .component('AddressSelector', defineAsyncComponent(() => import('./site/Components/Address/AddressSelector.vue')))
    .component('AddressList', defineAsyncComponent(() => import('./site/Components/Address/AddressList.vue')))
    .component('AddressItem', defineAsyncComponent(() => import('./site/Components/Address/AddressItem.vue')))
    .component('Modal', Modal)
    .component('Product', defineAsyncComponent(() => import('./site/Components/Product/Product.vue')))
    .component('ProductOverview', defineAsyncComponent(() => import('./site/Components/Product/ProductOverview.vue')))
    .component('ContactForm', defineAsyncComponent(() => import('./site/Components/Form/ContactForm.vue')))
    .component('NewsletterForm', defineAsyncComponent(() => import('./site/Components/Form/NewsletterForm.vue')))
    .component('OfferOverview', defineAsyncComponent(() => import('./site/Components/Offer/OfferOverview.vue')))
    .component('OfferHeader', OfferHeader)
    .component('SearchBar', SearchBar)
    .component('VideoWrapper', defineAsyncComponent(() => import('./site/Components/VideoWrapper.vue')))
    .component('CartStatus', defineAsyncComponent(() => import('./site/Components/Cart/CartStatus.vue')))
    // Async / lazy load components
    .component('skeleton', defineAsyncComponent(() => import('./site/Components/Skeleton.vue')))
    .component('prevent-interaction', defineAsyncComponent(() => import('./site/Components/PreventInteraction.vue')))
    .component('row-slider', defineAsyncComponent(() => import('./site/Components/RowSlider.vue')))
    .component('background-slider', defineAsyncComponent(() => import('./site/Components/BackgroundSlider.vue')))
    .component('Skeleton', Skeleton)
    .component('Messages', Messages)
    .component('ProductImages', Images)
    .component('ProductTabs', ProductTabs)
    .component('RelatedProducts', RelatedProducts)
    .component('AddToCartDetail', AddToCartDetail)
    .component('AfterAdding', AfterAdding)
    .component('AfterAddingOffer', AfterAddingOffer)
    .component('MainMenu', MainMenu)
    .component('CategoryMenu', CategoryMenu)
    .component('LanguageMenu', LanguageMenu)
    .component('MobileMenu', MobileMenu)
    .component('PreventInteraction', PreventInteraction)
    .component('StarRating', StarRating)
    .component('StockDetail', StockDetail)
    .component('selected-icon', defineAsyncComponent(() => import('./site/Components/SelectedIcon.vue')))
    .component('product-carousel', defineAsyncComponent(() => import('./site/Components/Product/ProductCarousel.vue')))
    .component('category-carousel', defineAsyncComponent(() => import('./site/Components/Category/CategoryCarousel.vue')))
    .component('model-carousel', defineAsyncComponent(() => import('./site/Components/ModelCarousel.vue')))
    .component('multi-carousel', defineAsyncComponent(() => import('./site/Components/MultiCarousel.vue')))
    .component('toggle-row-buttons', defineAsyncComponent(() => import('./site/Components/ToggleRowButtons.vue')))
    .component('pebble-carousel', defineAsyncComponent(() => import('./site/Components/PebbleCarousel.vue')))
    .component('carousel', defineAsyncComponent(() => import('./site/Components/Carousel.vue')))
    .component('carousel-item', defineAsyncComponent(() => import('./site/ui/carousel/CarouselItem.vue')))
    .component('faq-search', defineAsyncComponent(() => import('./site/Components/Faq/Search.vue')))
    .component('write-review', defineAsyncComponent(() => import('./site/Components/Product/WriteReview.vue')))
    .component('AccountHeader', AccountHeader)
;

app.mount('#app');
